module.exports = __webpack_public_path__ + "assets/img/form-title.794e7dcd.png";